/* GL3d: snelle toevoeging op de kaart (eigen code). Maximaal 5 stuks per bestelling. */
(function () {
  if (window.__mbdCard) return; window.__mbdCard = true;
  var MAX = 5;
  function cartCount() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { return c.item_count || 0; }); }
  function note(card, msg) {
    var n = card.querySelector('.mbd-qa__note');
    if (!n) { n = document.createElement('div'); n.className = 'mbd-qa__note'; n.setAttribute('role', 'status'); card.querySelector('.mbd-card__media').appendChild(n); }
    n.textContent = msg; n.hidden = false; clearTimeout(n._t); n._t = setTimeout(function () { n.hidden = true; }, 3500);
  }
  /* de wagenlade ververst met de secties van de winkel en opent; lukt dat niet, dan naar de wagenpagina */
  function refreshDrawer(d) {
    if (!d) { window.location.href = '/cart'; return; }
    fetch('/?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (sec) {
      var nd = new DOMParser().parseFromString(sec['cart-drawer'], 'text/html').querySelector('cart-drawer');
      if (!nd) throw 0;
      d.classList.toggle('is-empty', nd.classList.contains('is-empty')); d.innerHTML = nd.innerHTML;
      var ov = d.querySelector('#CartDrawer-Overlay'); if (ov && d.close) ov.addEventListener('click', d.close.bind(d));
      var bub = document.getElementById('cart-icon-bubble'); var nb = new DOMParser().parseFromString(sec['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (bub && nb) bub.innerHTML = nb.innerHTML;
      if (d.open) d.open(); else d.classList.add('active');
    }).catch(function () { window.location.href = '/cart'; });
  }
  function closeAll() { document.querySelectorAll('[data-mbd-sheet]').forEach(function (s) { s.hidden = true; }); document.querySelectorAll('[data-mbd-qa]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); }
  function add(card, id) {
    cartCount().then(function (n) {
      if (n + 1 > MAX) { note(card, 'You can order up to ' + MAX + ' bags per order.'); return; }
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: +id, quantity: 1 }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (x) {
          if (!x.ok) { note(card, x.j.description || 'Could not add this bag.'); return; }
          closeAll(); refreshDrawer(document.querySelector('cart-drawer'));
        });
    }).catch(function () { note(card, 'Something went wrong. Please try again.'); });
  }
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-mbd-qa]'), sz = e.target.closest('.mbd-qa__size'), x = e.target.closest('[data-mbd-close]');
    if (qa) {
      var card = qa.closest('[data-mbd-card]');
      if (qa.dataset.variant) { add(card, qa.dataset.variant); return; }
      var sh = card.querySelector('[data-mbd-sheet]'), open = sh.hidden;
      closeAll(); sh.hidden = !open; qa.setAttribute('aria-expanded', open ? 'true' : 'false'); return;
    }
    if (sz) { add(sz.closest('[data-mbd-card]'), sz.dataset.variant); return; }
    if (x) { closeAll(); return; }
    if (!e.target.closest('[data-mbd-sheet]')) closeAll();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
})();
